import React from "react";

const Spot = () => {
  return <div>Spot</div>;
};

export default Spot;
